import React from 'react';
import classnames from 'classnames';
import { SdfButton, SdfSpotIllustration } from '@synerg/react-components';
import { useLocation } from 'react-router-dom';
import './accessDenied.scss';

const logout = () => {
	const { origin } = window.location;
	window.location.href = `${origin}/self-service/api/logout`;
};

const AccessDenied = ({roles}) => {
	const { search } = useLocation();
	const error = search === '?error=true';
	const unauthorizedAccess = search === '?error=unauthorized';
	const isArchivedPartner = (roles || []).includes('selfserviceparnterarchived');
	
	return (
		<div className="access-denied__banner">
			<div className="access-denied__banner__container">
				<SdfSpotIllustration illustrationName={"lock"} size={"lg"} />
				<span className={classnames('text-heading-05 font-bold m-4', error && 'error')} >
					{isArchivedPartner ? 'Your access has been disabled.' : error ? 'Unable to complete your request' : 'Access Denied'}
				</span>
				<span className="text-body-02">
					{isArchivedPartner ? 'Please reach out to your ADP Marketplace contact if you have any questions.'
						: error && !isArchivedPartner
						? 'An unknown issue has occurred. We apologize for the inconvenience.' 
						: (unauthorizedAccess 
							? 'Your ADP account does not have access to this page. Please double-check the URL in your browser.'
							: (roles.length === 0
							? 'Your ADP account does not have permission to use this app'
							:'Your ADP account does not have permission to access this section of this app')
					)}
				</span>
				{error && !isArchivedPartner && <span className="pt-4">
					<SdfButton onClick={logout} emphasis="secondary">LOG OUT</SdfButton>
				</span>}
			</div>
		</div>
	);
};

export default AccessDenied;
